const colorOne = '#9b7ece'
const colorTwo = '#899adc'
const colorThree = '#6db1e8'
const colorFour = '#46d2a6'
const colors = [colorOne, colorTwo, colorThree, colorFour]

export default colors